module.exports = __webpack_public_path__ + "assets/img/advantage-bottom-bg.57c69ae8.png";